// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "index" + "." + "5704f9b7bc6ccd9de053" + ".js";
};